/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ "webfontloader");

  webFontLoader.load({
    google: {
      families: [
        "Noto Sans Japanese:400,500,600,700,800,900",
        "Noto Sans CJK JP:400,500,600,700,800,900",
        "NotoSansCJKjp:400,500,600,700,800,900",
      ],
    },
  });
}
